/**
 * Manifest — tableau de bord admin (SAAS-1219).
 *
 * @remarks
 * Derrière le flag `admin-dashboard` : la page est câblée sur les routes
 * existantes, mais reste cachée tant qu'elle n'a pas été validée sur des
 * données réelles.
 */

import { LayoutList } from 'lucide-react';
import { ADMIN_GUARD } from '../admin-guard';
import { CONTEXTS, lazyView, type FeatureManifest } from '@/app/registry';
import { ADMIN_DASHBOARD_FEATURE_FLAG } from './dashboard-flag';
import { adminDashboardRoutes } from './routes';

export const adminDashboardManifest: FeatureManifest = {
  id: 'admin-dashboard',
  contexts: [CONTEXTS.ADMIN_DASHBOARD],

  routes: [
    { routes: adminDashboardRoutes, errorFallbackLabel: 'Tableau de bord', guard: ADMIN_GUARD },
  ],

  centerView: {
    [CONTEXTS.ADMIN_DASHBOARD]: lazyView(
      () => import('../views/AdminDashboardView'),
      'AdminDashboardView',
    ),
  },

  panels: {
    left: {
      tabs: {
        [CONTEXTS.ADMIN_DASHBOARD]: [
          {
            id: 'admin-nav',
            label: 'Navigation',
            icon: LayoutList,
            view: lazyView(() => import('../views/AdminNavView'), 'AdminNavView'),
          },
        ],
      },
    },
  },

  enabledWhen: {
    roles: ['admin'],
    featureFlag: ADMIN_DASHBOARD_FEATURE_FLAG,
  },

  panelRequirements: {
    [CONTEXTS.ADMIN_DASHBOARD]: {
      left: { open: true, defaultActiveTab: 'admin-nav' },
      right: { open: false },
    },
  },
};
